import ApplicationController from '../../support/application_controller'
import WizardMixin           from '../../support/wizard_mixin'
import mixin                 from '../../support/mixin'

export default class extends mixin(
  ApplicationController,
  WizardMixin
) {

  static targets = [
    'freeText',
    'noneOfTheAbove',
    'preference',
    'prescriptionItemsNoneOfTheAbove',
    'prescriptionNoneOfTheAboveSubtitle',
    'primaryNumber',
    'recommendationItemsNoneOfTheAbove',
    'recommendationNoneOfTheAboveSubtitle',
    'updatePrimaryNumber'
  ]

  static classes = [
    'hide'
  ]

  connect() {
    this.togglePreferences()
  }

  // ==== Getters

  // ==== Setters

  // ==== Actions

  toggleUpdatePrimaryNumber({ params: { patientNumber } }) {
    this.updatePrimaryNumberTarget.classList.toggle(this.hideClass, this.primaryNumberTarget.value === patientNumber)
  }

  togglePrescriptionItemsNoneOfTheAbove({ currentTarget }) {
    if (currentTarget.value === 'none_of_the_above') {
      this.prescriptionNoneOfTheAboveSubtitleTarget.classList.toggle(this.hideClass, !currentTarget.checked)
    }

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this.prescriptionItemsNoneOfTheAboveTargets,
      dispatchInput: true
    })
  }

  toggleRecommendationItemsNoneOfTheAbove({ currentTarget }) {
    if (currentTarget.value === 'none_of_the_above') {
      this.recommendationNoneOfTheAboveSubtitleTarget.classList.toggle(this.hideClass, !currentTarget.checked)
    }

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this.recommendationItemsNoneOfTheAboveTargets,
      dispatchInput: true
    })
  }

  togglePreferences() {
    const hidePreferences = this.noneOfTheAboveTargets.every((input) => input.checked) && !this.hasFreeTextTarget
    this.preferenceTargets.forEach((preference) => {
      preference.classList.toggle(this.hideClass, hidePreferences)
    })
  }

  // ==== Private

  // ==== Channels

}
